module.exports = __webpack_public_path__ + "static/image/history/pc/201911.ver2_0_2.jpg?f27e9f57";